import { ComponentStyleConfig } from "@chakra-ui/react";
import textStyles from "theme/textStyles";

const constructButtonStyle = (
  bg: string,
  color: string,
  hover: any,
  focus: any,
  disabled: any
) => ({
  bg,
  color,
  ...textStyles.cta,
  _active: hover,
  _hover: {
    ...hover,
    _disabled: disabled,
  },
  _focus: focus,
  _focusWithin: focus,
  _focusVisible: focus,
  _disabled: disabled,
});

const outlineProps = {
  outlineWidth: "2px",
  outlineOffset: 0,
};
const Button: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: "base",
    _disabled: {
      opacity: 0.12,
    },
  },
  variants: {
    primary: ({ colorScheme }) => {
      const _disabled = {
        bg: `${colorScheme}.700`,
      };
      const _hover = {
        bg: `${colorScheme}.700`,
      };
      const _focus = {
        ...outlineProps,
        bg: `${colorScheme}.700`,
        outlineColor: `${colorScheme}.600`,
      };
      return constructButtonStyle(
        `${colorScheme}.600`,
        "white",
        _hover,
        _focus,
        _disabled
      );
    },
    secondary: ({ colorScheme }) => {
      const _disabled = {
        bg: `${colorScheme}.100`,
        opacity: 0.4,
      };
      const _hover = {
        bg: `${colorScheme}.200`,
      };
      const _focus = {
        ...outlineProps,
        bg: `${colorScheme}.200`,
        outlineColor: `${colorScheme}.400`,
      };
      return constructButtonStyle(
        `${colorScheme}.100`,
        "black",
        _hover,
        _focus,
        _disabled
      );
    },
    danger: ({ colorScheme }) => {
      const _disabled = {
        bg: `${colorScheme}.600`,
      };
      const _hover = {
        bg: `${colorScheme}.600`,
      };
      const _focus = {
        ...outlineProps,
        bg: `${colorScheme}.700`,
        outlineColor: `${colorScheme}.900`,
      };
      return constructButtonStyle(
        `${colorScheme}.500`,
        "white",
        _hover,
        _focus,
        _disabled
      );
    },
    outline: ({ colorScheme }) => {
      const _disabled = {
        color: "grey.200",
        opacity: 1,
        borderColor: "inherit",
      };
      const _hover = {
        bg: `${colorScheme}.50`,
      };
      const _focus = {
        bg: `${colorScheme}.100`,
      };
      return {
        ...constructButtonStyle(
          `unset`,
          `${colorScheme}.600`,
          _hover,
          _focus,
          _disabled
        ),
        border: "2px solid",
        borderColor: `${colorScheme}.600`,
      };
    },
    link: ({ colorScheme }) => {
      const _disabled = {
        textDecoration: "underline",
      };
      const _hover = {
        textDecoration: "underline",
        color: `${colorScheme}.800`,
      };
      const _focus = {
        ...outlineProps,
        textDecoration: "underline",
        outlineColor: `${colorScheme}.700`,
      };
      return constructButtonStyle(
        `unset`,
        `${colorScheme}.600`,
        _hover,
        _focus,
        _disabled
      );
    },
  },
  defaultProps: {
    size: "lg",
  },
};

export default Button;
